import React from "react";

/**
 * PlayerAvatar
 * Reusable avatar component for displaying players with emoji and color
 * Used in both Lobby and GameHeader
 */
const PlayerAvatar = ({
  playerName,
  playerColor,
  playerEmoji,
  isReady = false,
  showReadyIndicator = false,
  size = 'medium', // 'small', 'medium', 'large'
  showLabel = true,
  className = '',
  selfColor = undefined
}) => {
  const sizeMap = {
    tiny: { circle: '28px', icon: '1rem', label: '0.6rem' },
    small: { circle: '40px', icon: '1.5rem', label: '0.7rem' },
    medium: { circle: '60px', icon: '2.2rem', label: '0.85rem' },
    large: { circle: '80px', icon: '3rem', label: '1rem' }
  };

  const sizes = sizeMap[size] || sizeMap.medium;

  const avatarColor = playerColor || '#666666';
  
  return (
    <div className={`player-avatar ${className}`} style={selfColor ? { '--self-color': selfColor } : undefined}>
      <div 
        className="avatar-circle"
        style={{
          width: sizes.circle,
          height: sizes.circle,
          backgroundColor: avatarColor,
          borderColor: avatarColor,
          boxShadow: `0 4px 12px ${avatarColor}40`,
        }}
      >
        <span className="avatar-icon" style={{ fontSize: sizes.icon }}>
          {playerEmoji || '🎮'}
        </span>
        {showReadyIndicator && isReady && (
          <div className="avatar-ready-indicator">
            <span className="avatar-ready-indicator-icon">✓</span>
          </div>
        )}
      </div>
      {showLabel && (
        <>
          <span className="avatar-label" style={{ fontSize: sizes.label }}>
            {playerName}
          </span>
          {showReadyIndicator && (
            <span 
              className={`avatar-ready-status ${isReady ? 'ready' : 'not-ready'}`}
              style={{ fontSize: sizes.label }}
            >
              {isReady ? '✓ Ready' : 'Not ready'}
            </span>
          )}
        </>
      )}
    </div>
  );
};

export default PlayerAvatar;

